export default "__VITE_ASSET__CAB9nhjX__"